import { withTranslation } from 'react-i18next';
import React from 'react';
import {URI} from '../../URI';
import iconPeopleWhite from '../../assets/svg/app-icon-nobg.svg';

class Main extends React.Component {
    render() {
        return(
            <div className="login-wrapper">
                <div className="container">
                    <img src={iconPeopleWhite} alt="Logo"/>
                    <h1>{this.props.t('login.appName')}</h1>
                    <p className="lead">{this.props.mainText}</p>
                    <a
                        href={URI.schedule}
                        className="btn btn-default">
                       {this.props.t('notAllowed.goToSchedule')}
                    </a>
                </div>
            </div>
        );
    }
}


export default withTranslation()(Main);
